import Layout from '@/layout/Layout.vue';
import { AUTH_KEYS } from '@/constants';
export default {
  path: '/account/trans',
  component: Layout,
  name: 'Transport Account',
  meta: { title: 'account_information_update', auth: AUTH_KEYS.ACCOUNT_PAGE },
  children: [
    {
      path: '/account/trans',
      component: () => import('@/views/TransAccountInfo/Index.vue'),
      meta: { title: 'Trans Account Info Update', auth: AUTH_KEYS.TRANS_ACCOUNT_INFO_REGISTER }
    }
  ]
};
